import ObjectsAPI from '../api/Objects';
import PropertyApi from '../api/Property';
import PersonalObjectsAPI from '../api/PersonalProperty';
import CalendarsAPI from '../api/Calendars';
import ExportsAPI from '../api/Exports';
import * as ObjectConst from '../constants/Property';
import * as ActionTypes from '../constants/ActionTypes';

export const createObject = (authorId) => dispatch => {
    const objectCreateCommand = {
        props: {
            authorId: authorId,
            type: ObjectConst.TYPE.RENT
        }
    };

    ObjectsAPI.createObject(objectCreateCommand)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.CREATING_OBJECT,
                payload: data
            });
        });
};

export const stopRedirect = () => ({
    type: ActionTypes.SET_REDIRECT,
    payload: false
});

export const setNeedCreateObject = isNeedCreateObject => ({
    type: ActionTypes.SET_NEED_CREATE_OBJECT,
    isNeedCreateObject
});

export const getCreatedObject = objectId => dispatch => {
    const embed = [
        ObjectConst.EMBED.USER,
        ObjectConst.EMBED.IMAGES,
        ObjectConst.EMBED.GOOGLEADDRESS,
        ObjectConst.EMBED.EXTERNALCALENDARS,
        ObjectConst.EMBED.EXPORT
    ];

    return PropertyApi.getProperty(objectId, embed)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.GET_CREATED_OBJECT,
                payload: data
            });
        });
};

export const updateField = (objectId, updateFieldCommand) => dispatch => {
    ObjectsAPI.updateField(objectId, updateFieldCommand)
        .then(() => {
            if (
                updateFieldCommand.name === ObjectConst.FIELDS.STATUS &&
                updateFieldCommand.value === ObjectConst.STATUS.ACTIVE
            ) {
                dispatch({
                    type: ActionTypes.SET_REDIRECT_TO_OBJECT_PAGE,
                    payload: true
                });
            }
        });

    dispatch({
        type: ActionTypes.UPDATE_FIELD,
        payload: {
            name: updateFieldCommand.name,
            value: updateFieldCommand.value
        }
    });
};

export const publishObject = (objectId) => dispatch => {
    PersonalObjectsAPI
        .publishObject(objectId)
        .then(() => {
            dispatch({
                type: ActionTypes.SET_REDIRECT_TO_OBJECT_PAGE,
                payload: true
            });
        })
        .catch(e => {
            console.log(e);
        })
    ;
};

export const setRedirectToObjectPage = isRedirectToObjectPage => ({
    type: ActionTypes.SET_REDIRECT_TO_OBJECT_PAGE,
    payload: isRedirectToObjectPage
});

export const addImages = (objectId, images) => dispatch => {
    dispatch({
        type: ActionTypes.SET_IS_SHOW_PROGRESS_BAR,
        payload: true
    });

    ObjectsAPI.addImages(objectId, images, dispatch)
        .then(() => {
            const embed = [
                ObjectConst.EMBED.IMAGES,
                ObjectConst.EMBED.GOOGLEADDRESS
            ];

            dispatch({
                type: ActionTypes.SET_IS_SHOW_PROGRESS_BAR,
                payload: false
            });

            ObjectsAPI.getObjectById(objectId, embed)
                .then(({data}) => {
                    dispatch({
                        type: ActionTypes.GET_CREATED_OBJECT,
                        payload: data
                    });
                });
        })
};

export const deleteImage = (objectId, imageId) => dispatch => {
    ObjectsAPI.deleteImage(objectId, imageId);

    dispatch({
        type: ActionTypes.DELETE_IMAGE,
        payload: imageId
    });
};

export const updateMainPhotoURL = mainPhotoURL => ({
    type: ActionTypes.UPDATE_MAIN_PHOTO_URL,
    payload: mainPhotoURL
});

export const updatePhotoOrders = images => ({
    type: ActionTypes.UPDATE_PHOTO_ORDERS,
    payload: images
});

export const loadCalendar = (objectId, calendarSearchCommand, getCancelSource) => dispatch => {
    dispatch({
        type: ActionTypes.CREATING_PROPERTY_CHANGE_CALENDAR_LOADING,
        payload: true
    });

    CalendarsAPI.getCalendars(objectId, calendarSearchCommand, getCancelSource)
        .then(({data: {days, currency}}) => {
            dispatch({
                type: ActionTypes.CREATING_PROPERTY_SET_CURRENT_DAYS,
                payload: {
                    currentDays: days,
                    currency: currency
                }
            })
        });
};

export const updateDays = (objectId, updateDaysCommand) => dispatch => {
    CalendarsAPI.update(objectId, updateDaysCommand);

    dispatch({
        type: ActionTypes.CREATING_PROPERTY_UPDATE_DAYS,
        payload: updateDaysCommand.days
    });
};

export const setGeneralInformationValid = isGeneralInformationValid => ({
    type: ActionTypes.SET_GENERAL_INFORMATION_VALID,
    payload: isGeneralInformationValid
});

export const setAddressValid = isAddressValid => ({
    type: ActionTypes.SET_ADDRESS_VALID,
    payload: isAddressValid
});

export const setPricesValid = isPricesValid => ({
    type: ActionTypes.SET_PRICES_VALID,
    payload: isPricesValid
});

export const setOtherValid = isOtherValid => ({
    type: ActionTypes.SET_OTHER_VALID,
    payload: isOtherValid
});

export const setExportValue = (objectId, exportName, exportField, value) => dispatch => {
        if (value) {
            ExportsAPI.enable(exportName, objectId)
                .then(() => {
                    dispatch({
                        type: ActionTypes.SET_EXPORT_VALUE,
                        exportField: exportField,
                        payload: value
                    })
                });
            return;

        }

        ExportsAPI.disable(exportName, objectId)
            .then(() => {
                dispatch({
                    type: ActionTypes.SET_EXPORT_VALUE,
                    exportField: exportField,
                    payload: value
                })
            });
    }
;



// WEBPACK FOOTER //
// ./src/actions/CreatingObjectPage.js